/** Presentation-only status resolution; the shared bridge validates the full cue identity. */
export function handleMagicTarget(message:{roll:Record<string,unknown>}):void {
    const roll=message.roll;
    const current=String(window.ftGetActiveEncounterId?.()||'').toUpperCase();
    if(!current||String(roll?.encounter_id||'').toUpperCase()!==current)return;
    if(!window.FateTide?.user?.isGM&&((Number(roll.roll_private||0)>0&&Number(roll.campaign_permission||0)!==1)
        ||Number(roll.roll_by_encounter_creature_private||0)>0||Number(roll.roll_to_encounter_creature_private||0)>0))return;
    const cue=roll.roll_vfx as Record<string,unknown>|undefined;
    if(!cue||cue.schema!=='ft.ft3d.magic-cue.v1'||String(cue.encounterId||'').toUpperCase()!==current)return;
    document.dispatchEvent(new CustomEvent('ft-magic-target-authorized',{detail:{roll}}));
}
